module.exports = __webpack_public_path__ + "static/media/logo_tree_white_small.df195a5b.png";